import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  addIconGallery,
  chakMarkWhite,
  closeIcon,
  clsoeIconActionIcon,
  DeleteActionIcon,
  deleteIconCircleOrange,
  dotsMenuIcon,
  eyeClose,
  eyeCloseBlack,
  gallery1,
  gallery10,
  gallery11,
  gallery12,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  hideShowActionIcon,
  menuDotsIcon,
  modalCloseIcon,
  MoveActionIcon,
  moveIocn,
  pinBlack,
  pinIconActionIcon,
  pinIocn,
  upgradeIcon,
} from "../../../../../images";
import config from "../../../../../config/config";
import Modal from "react-bootstrap/Modal";
import "./galleryPopupComn.scss";
import FileUpload from "../FileUpload/FileUpload";
import GallerypopupDeleteVariant from "./GallerypopupDeleteVariant";
import GalleryPopupRecentlyDeleted from "./GalleryPopupRecentlyDeleted";
import GalleryPopupMove from "./GalleryPopupMove";
import BottomSheetOptions from "./BottomSheetOptions";
import { useWindowSize } from "react-use";
import http from "../../../../../helpers/http";
import { toast } from "react-toastify";
import ToastMsg from "../../../../../components/ToastMsg/ToastMsg";
import { useBusinessContext } from "../../../../../context/BusinessAccount/BusinessAccountState";
import GalleryPinPopup from "./GalleryPinPopup";
import GalleryPopupHide from "./GalleryPopupHide";
import { ImageList, ImageListItem } from "@mui/material";
import DeleteConfirmPopup from "../DeleteConfirmPopup/DeleteConfirmPopup";
import MoveImagePopup from "../MoveImagePopup/MoveImagePopup";
import {
  chooseYourPlan,
  planDetails,
} from "../../../../../components/helpers/constant-words";
import GalleryPopupUnusedImages from "./GalleryPopupUnusedImages";
import BillingPopUp from "../BillingPopUp/BillingPopUp";
import BlurGalleryImage from "../../../../../components/BlurGalleryImage/BlurGalleryImage";
import useTheme from "../../../../../components/useTheme/useTheme";

const GalleryEditPopupDefault = (props) => {
  const { theme } = useTheme();
  const [localCategoryData, setLocalCategoryData] = useState(
    props.categoryData
  );

  const navigate = useNavigate();

  useEffect(() => {
    setLocalCategoryData(props.categoryData);
  }, [props.categoryData]);

  const galleryTitles = [
    { key: "project_renders_media", title: "Project Photos & Renders" },
    { key: "completed_products_media", title: "Products | Materials" },
    { key: "sites_inprogress_media", title: "Sites In Progress" },
    { key: "others_media", title: "Others" },
  ];

  const categoryKey = localCategoryData?.category?.key;
  const imagesData = localCategoryData?.data?.[categoryKey]?.filter(
    (a) => !a.isUnused
  );
  const totalImages = galleryTitles.reduce((sum, { key }) => {
    const images = localCategoryData?.data?.[key] || [];
    const activeImages = images.filter((img) => !img.isUnused); // only include !isUnused
    return sum + activeImages.length;
  }, 0);

  const images = [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,
    gallery11,
    gallery12,
  ];

  const { width } = useWindowSize();
  const [activeBtn, setActiveBtn] = useState(
    props.categoryData?.category?.key || "project_renders_media"
  ); // default active button

  const [columns, setColumns] = useState(4); // Default: 4 columns
  const [showFileUploadPopup, setShowFileUploadPopup] = useState(false);
  const deleteVariantRef = useRef(null);
  const [arrangedImages, setArrangedImages] = useState([]);
  const [activeGallerImages, setActiveGalleryImages] = useState(false);
  const [showOptionsPopup, setShowOptionsPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showMovePopup, setShowMovePopup] = useState(false);
  const [showGallerypopupDeleteVariant, setShowGallerypopupDeleteVariant] =
    useState(false);
  const [showGallerypopupRecentlyDeleted, setShowGallerypopupRecentlyDeleted] =
    useState(false);
  const [showGallerypopupUnusedImages, setShowGallerypopupUnusedImages] =
    useState(false);
  const [showGalleryPopupPin, setShowGalleryPopupPin] = useState(false);
  const [showHidePopup, setShowHidePopup] = useState(false);
  const [showBillingPopup, setShowBillingPopup] = useState(false);
  const handleBillingPopupClose = () => setShowBillingPopup(false);

  const aws_object_url = config.aws_object_url;
  const baseUrl = config.api_url;
  const BusinessContext = useBusinessContext();
  // useEffect(() => {
  //   const updateColumns = () => {
  //     if (window.innerWidth > 1200) setColumns(4);
  //     else if (window.innerWidth > 1024) setColumns(4);
  //     else if (window.innerWidth > 768) setColumns(4);
  //     else if (window.innerWidth > 340) setColumns(2);
  //     else setColumns(2);
  //   };

  //   updateColumns();
  //   window.addEventListener("resize", updateColumns);
  //   return () => window.removeEventListener("resize", updateColumns);
  // }, []);
  const TOTAL_STORAGE =
    BusinessContext?.data?.subscription?.plan?.features?.imagesLimit || 200;
  const RECENTLY_DELETED_LIMIT =
    BusinessContext?.data?.subscription?.plan?.features?.recentlyDeletedLimit ||
    100;

  const filledPercentage = Math.floor((totalImages / TOTAL_STORAGE) * 100);

  useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth > 1200) setColumns(4);
      else if (window.innerWidth > 1024) setColumns(4);
      else if (window.innerWidth > 768) setColumns(3);
      else if (window.innerWidth > 340) setColumns(2);
      else setColumns(2);
    };

    updateColumns(); // run initially
    window.addEventListener("resize", updateColumns);
    return () => window.removeEventListener("resize", updateColumns);
  }, []);

  useEffect(() => {
    createMasonryLayout(); // re-create when column count changes
  }, [columns, localCategoryData]);

  useEffect(() => {
    if (props.categoryData?.data) {
      const newCategory = galleryTitles.find((item) => item.key === activeBtn);
      if (newCategory) {
        setLocalCategoryData({
          category: newCategory,
          data: props.categoryData.data,
        });
      }
    }
  }, [activeBtn, props.categoryData?.data]);

  // Masonry logic: Arranging images row-wise instead of column-wise
  const createMasonryLayout = () => {
    let arranged = Array.from({ length: columns }, () => []);
    let columnHeights = Array(columns).fill(0);

    // const filteredImages = imagesData;

    // Sort images: pinned images first
    const filteredImages = imagesData?.sort((a, b) => {
      if (a.pinned === b.pinned) return 0;
      return a.pinned ? -1 : 1; // pinned=true goes first
    });

    filteredImages?.forEach((img) => {
      const shortestColumnIndex = columnHeights.indexOf(
        Math.min(...columnHeights)
      );
      arranged[shortestColumnIndex].push({
        id: img._id,
        section: categoryKey,
        src: `${aws_object_url}business/${img?.url}`,
        pinned: img.pinned,
        visibility: img.visibility,
        name: img?.name,
        height: img?.height,
        width: img?.width,
        blurHash: img?.blurHash,
      });
      columnHeights[shortestColumnIndex] += 1; // Assuming equal height for each image
      // FIX: use real image ratio instead of +1
      // const imageHeight = img.height / img.width;
      // columnHeights[shortestColumnIndex] += imageHeight;
    });
    setArrangedImages(arranged);
    return arranged;
  };

  const handleSoftDeleteImages = async (data) => {
    const imageIds = data.map((it) => it.id);
    const section = categoryKey;
    const response = await http.put(
      `${baseUrl}/business/soft-delete-images/${props?.categoryData?.data?._id}`,
      { imageIds: data }
    );

    if (response?.data) {
      const allImages = imagesData || [];

      const filteredImages = allImages.filter(
        (image) => !imageIds.includes(image._id)
      );

      const deletedImages = allImages.filter((image) =>
        imageIds.includes(image._id)
      );

      const updatedData = {
        ...localCategoryData.data,
        [section]: filteredImages,
        recently_deleted: {
          ...localCategoryData.data.recently_deleted,
          [section]: [
            ...(localCategoryData.data.recently_deleted?.[section] || []),
            ...deletedImages,
          ],
        },
      };

      setLocalCategoryData({
        ...localCategoryData,
        data: updatedData,
      });

      BusinessContext.update({
        ...BusinessContext.data,
        [section]: filteredImages,
        recently_deleted: {
          ...(BusinessContext.data.recently_deleted || {}),
          [section]: [
            ...(BusinessContext.data.recently_deleted?.[section] || []),
            ...deletedImages,
          ],
        },
      });
      createMasonryLayout();
      handleGallerypopupDeleteVariantClose();
      if (
        deleteVariantRef.current &&
        deleteVariantRef.current.handleShowDeletePopupClose
      ) {
        deleteVariantRef.current.handleShowDeletePopupClose();
      }
      toast(
        <ToastMsg message="Image(s) deleted. You can restore them within 30 days." />,
        config.success_toast_config
      );
      deleteVariantRef.current.resetCheckedItems();
      setShowGallerypopupDeleteVariant(false);
    }
  };

  // State all images

  const handleSelectAll = () => {
    setActiveGalleryImages(true);

    const allItems = {};
    const allImages = [];

    arrangedImages.forEach((column, colIndex) => {
      column.forEach((item, index) => {
        const itemKey = `${colIndex}-${index}`;
        allItems[itemKey] = true;
        allImages.push(item);
      });
    });

    setCheckedItems(allItems);
    setSelectedImages(allImages);
  };

  const handlePermanentlyDeleteImages = async (data) => {
    const imageIds = data.map((it) => it.id);
    const section = categoryKey;
    const response = await http.put(`${baseUrl}/business/delete-images`, {
      imageIds,
    });

    if (response?.data) {
      const filteredImages = localCategoryData?.data?.recently_deleted[
        section
      ]?.filter((image) => !imageIds?.includes(image?._id));

      const updatedData = {
        ...localCategoryData.data,
        recently_deleted: {
          ...localCategoryData.data.recently_deleted,
          [section]: filteredImages,
        },
      };
      setLocalCategoryData({ ...localCategoryData, data: updatedData });
      BusinessContext.update({
        ...BusinessContext.data,
        recently_deleted: {
          ...BusinessContext.data.recently_deleted,
          [section]: filteredImages,
        },
      });

      createMasonryLayout();
      handleGallerypopupDeleteVariantClose();
      if (
        deleteVariantRef.current &&
        deleteVariantRef.current.handleShowDeletePopupClose
      ) {
        deleteVariantRef.current.handleShowDeletePopupClose();
      }
      toast(
        <ToastMsg message="Image(s) permanently deleted." />,
        config.success_toast_config
      );
      deleteVariantRef.current.resetCheckedItems();
      setShowGallerypopupRecentlyDeleted(false);
    }
  };

  const handlePinImages = async (data) => {
    const { pinnedImages, unpinnedImages } = data;
    const section = categoryKey;

    const response = await http.put(`${baseUrl}/business/pin-images`, {
      pinnedImages,
      unpinnedImages,
    });

    if (response?.data) {
      // Update props.categoryData.data
      const updatedImages = imagesData?.map((image) => ({
        ...image,
        pinned: pinnedImages.includes(image._id)
          ? true
          : unpinnedImages.includes(image._id)
          ? false
          : image.pinned, // Preserve existing pinned status if not in pinned/unpinned lists
      }));
      const updatedData = {
        ...localCategoryData.data,
        [section]: updatedImages,
      };
      setLocalCategoryData({ ...localCategoryData, data: updatedData });
      // Update BusinessContext
      BusinessContext.update({
        ...BusinessContext.data,
        [section]: updatedImages,
      });
      createMasonryLayout();
      if (activeGallerImages) {
        setActiveGalleryImages(false);
        setSelectedImages([]);
        setCheckedItems({});
      }

      // Show success toast
      toast(
        <ToastMsg message="Image(s) updated successfully." />,
        config.success_toast_config
      );
      setShowGalleryPopupPin(false);
    }
  };

  const handleSinglePinImage = async (item) => {
    if (item?.visibility === false) {
      toast(
        <ToastMsg message="Hidden Image cannot be Pinned" danger={true} />,
        config.error_toast_config
      );
    } else {
      const currentlyPinnedCount =
        imagesData?.filter((image) => image.pinned)?.length || 0;
      if (!item.pinned && currentlyPinnedCount >= 5) {
        toast(
          <ToastMsg
            message="Cannot pin more than 5 images. Please unpin some images."
            danger={true}
          />,
          config.error_toast_config
        );
        return;
      }
      const isPinned = item.pinned;
      const data = {
        pinnedImages: isPinned ? [] : [item.id],
        unpinnedImages: isPinned ? [item.id] : [],
      };
      await handlePinImages(data);
      setActiveMenuId(null);
    }
  };

  const handleHideImages = async (data) => {
    const { hiddenImages, visibleImages } = data;
    const section = categoryKey;
    const response = await http.put(`${baseUrl}/business/hide-images`, {
      hiddenImages,
      visibleImages,
    });

    if (response?.data) {
      // Update props.categoryData.data
      const updatedImages = imagesData?.map((image) => ({
        ...image,
        visibility: visibleImages.includes(image._id)
          ? true
          : hiddenImages.includes(image._id)
          ? false
          : image.visibility,
      }));

      const updatedData = {
        ...localCategoryData.data,
        [section]: updatedImages,
      };
      setLocalCategoryData({ ...localCategoryData, data: updatedData });
      // Update BusinessContext
      BusinessContext.update({
        ...BusinessContext.data,
        [section]: updatedImages,
      });
      createMasonryLayout();

      if (activeGallerImages) {
        setActiveGalleryImages(false);
        setSelectedImages([]);
        setCheckedItems({});
      }

      // Show success toast
      toast(
        <ToastMsg message="Image(s) updated successfully." />,
        config.success_toast_config
      );
      setShowHidePopup(false);
    }
  };

  const handleSingleHideImage = async (item) => {
    if (item?.pinned === true) {
      toast(
        <ToastMsg message="Pinned Image cannot be Hidden" danger={true} />,
        config.error_toast_config
      );
    } else {
      const isHidden = item.visibility;
      const data = {
        visibleImages: isHidden ? [] : [item.id],
        hiddenImages: isHidden ? [item.id] : [],
      };
      await handleHideImages(data);
      setActiveMenuId(null);
    }
  };

  const handleMoveImages = async (selectedFolder, selectedImages) => {
    const imageIds = selectedImages.map((it) => it.id);
    const sourceSection = categoryKey;
    const destinationSection = selectedFolder?.key;
    const response = await http.put(`${baseUrl}/business/move-images`, {
      imageIds,
      section: destinationSection,
    });

    if (response?.data) {
      const imagesToMove = imagesData?.filter((image) =>
        imageIds.includes(image._id)
      );

      const updatedDestinationImages = [
        ...(localCategoryData?.data?.[destinationSection] || []),
        ...imagesToMove,
      ];
      const updatedSourceImages = imagesData?.filter(
        (image) => !imageIds.includes(image._id)
      );

      const updatedData = {
        ...localCategoryData.data,
        [sourceSection]: updatedSourceImages,
        [destinationSection]: updatedDestinationImages,
      };
      setLocalCategoryData({ ...localCategoryData, data: updatedData });
      BusinessContext.update({
        ...BusinessContext.data,
        [destinationSection]: updatedDestinationImages,
        [sourceSection]: updatedSourceImages,
      });

      createMasonryLayout();
      handleGallerypopupMoveClose();
      if (
        deleteVariantRef.current &&
        deleteVariantRef.current.handleShowDeletePopupClose
      ) {
        deleteVariantRef.current.handleShowDeletePopupClose();
      }
      toast(
        <ToastMsg
          message={`Image(s) moved to ${selectedFolder?.folderName}`}
        />,
        config.success_toast_config
      );
      setSelectedImages([]);
      setShowMovePopup(false);
    }
    // Get images to move with their full data
  };

  const handleRestoreImages = async (data) => {
    const imageIds = data.map((it) => it.id);
    const section = categoryKey;

    const response = await http.put(`${baseUrl}/business/restore-images`, {
      imageIds: data,
    });

    if (response?.data) {
      const restoredImages = localCategoryData?.data?.recently_deleted?.[
        section
      ]?.filter((image) => imageIds.includes(image._id));

      const filteredImages = localCategoryData?.data?.recently_deleted?.[
        section
      ]?.filter((image) => !imageIds.includes(image._id));
      const updatedSectionImages = [
        ...(localCategoryData?.data?.[section] || []),
        ...restoredImages,
      ];

      const updatedData = {
        ...localCategoryData.data,
        recently_deleted: {
          ...localCategoryData.data.recently_deleted,
          [section]: filteredImages,
        },
        [section]: updatedSectionImages,
      };
      setLocalCategoryData({ ...localCategoryData, data: updatedData });

      BusinessContext.update({
        ...BusinessContext.data,
        recently_deleted: {
          ...BusinessContext.data.recently_deleted,
          [section]: filteredImages,
        },
        [section]: updatedSectionImages,
      });

      createMasonryLayout();
      handleGallerypopupDeleteVariantClose();
      if (
        deleteVariantRef.current &&
        deleteVariantRef.current.handleShowDeletePopupClose
      ) {
        deleteVariantRef.current.handleShowDeletePopupClose();
      }
      toast(
        <ToastMsg message="Image(s) restored successfully." />,
        config.success_toast_config
      );
      setShowGallerypopupRecentlyDeleted(false);
    }
  };

  const handleBulkPinImages = () => {
    // Filter out images that are already hidden (hidden images cannot be pinned)
    const validImages = selectedImages.filter(
      (image) => image.visibility !== false
    );

    if (validImages.length === 0) {
      toast(
        <ToastMsg message="Hidden images cannot be pinned." danger={true} />,
        config.error_toast_config
      );
      return;
    }

    if (validImages.length !== selectedImages.length) {
      toast(
        <ToastMsg message="Some images were skipped as hidden images cannot be pinned." />,
        config.warning_toast_config
      );
    }

    const currentlyPinnedCount =
      imagesData?.filter((image) => image.pinned)?.length || 0;

    // Get images that need to be pinned (not already pinned)
    const imagesToPin = validImages
      .filter((image) => !image.pinned)
      .map((image) => image.id);
    const imagesToUnpin = validImages
      .filter((image) => image.pinned)
      .map((image) => image.id);

    // Check if pinning these images would exceed the 5-image limit
    const totalAfterPinning =
      currentlyPinnedCount - imagesToUnpin.length + imagesToPin.length;

    if (totalAfterPinning > 5) {
      toast(
        <ToastMsg
          message="Cannot pin more than 5 images. Please unpin some images first."
          danger={true}
        />,
        config.error_toast_config
      );
      return;
    }

    const data = {
      pinnedImages: imagesToPin,
      unpinnedImages: imagesToUnpin,
    };
    handlePinImages(data);
    handleClearSelection();
  };

  const handleBulkHideImages = () => {
    // Filter out images that are already pinned (pinned images cannot be hidden)
    const validImages = selectedImages.filter((image) => !image.pinned);

    if (validImages.length === 0) {
      toast(
        <ToastMsg message="Pinned images cannot be hidden." danger={true} />,
        config.error_toast_config
      );
      return;
    }

    if (validImages.length !== selectedImages.length) {
      toast(
        <ToastMsg message="Some images were skipped as pinned images cannot be hidden." />,
        config.warning_toast_config
      );
    }

    // Separate into images to hide and show
    const imagesToHide = validImages
      .filter((image) => image.visibility !== false)
      .map((image) => image.id);
    const imagesToShow = validImages
      .filter((image) => image.visibility === false)
      .map((image) => image.id);

    const data = {
      hiddenImages: imagesToHide,
      visibleImages: imagesToShow,
    };

    handleHideImages(data);
    handleClearSelection();
  };

  const handleUpdateData = (updatedData) => {
    setLocalCategoryData({
      ...localCategoryData,
      data: updatedData,
    });
    // Also update the BusinessContext to keep parent in sync
    BusinessContext.update(updatedData);

    createMasonryLayout();
  };

  const [isHovered, setIsHovered] = useState(false);
  const [activeMenuId, setActiveMenuId] = useState(null);
  const [checkedItems, setCheckedItems] = useState({});
  const [selectedImages, setSelectedImages] = useState([]);
  const menuRef = useRef(null);
  const handleFileUploadPopupOpen = () => setShowFileUploadPopup(true);
  const handleFileUploadPopupClose = async () => {
    const updatedData = await BusinessContext.fetchData(
      BusinessContext?.data?._id
    );
    handleUpdateData(updatedData);
    setShowFileUploadPopup(false);
  };
  const handleRecentlyDeletedPopupOpen = () =>
    setShowGallerypopupRecentlyDeleted(true);
  const handleRecentlyDeletedPopupClose = () =>
    setShowGallerypopupRecentlyDeleted(false);
  const handleUnusedImagesPopupOpen = () =>
    setShowGallerypopupUnusedImages(true);
  const handleUnusedImagesPopupClose = () =>
    setShowGallerypopupUnusedImages(false);
  const handleGallerypopupDeleteVariantOpen = () =>
    setShowGallerypopupDeleteVariant(true);
  const handleGallerypopupDeleteVariantClose = () =>
    setShowGallerypopupDeleteVariant(false);
  const handleGallerypopupMoveOpen = () => setShowMovePopup(true);
  const handleGallerypopupMoveClose = () => setShowMovePopup(false);
  // const handleOptionsPopupOpen = () => setShowOptionsPopup(true);
  const handleOptionsPopupOpen = (item) => {
    setSelectedImages([item]); // select the clicked image
    setShowOptionsPopup(true); // show bottom sheet
  };

  const handleOptionsPopupClose = () => setShowOptionsPopup(false);
  const handlePinPopupOpen = () => setShowGalleryPopupPin(true);
  const handlePinPopupClose = () => setShowGalleryPopupPin(false);
  const handleHidePopupOpen = () => {
    setShowHidePopup(true);
  };
  const handleHidePopupClose = () => setShowHidePopup(false);
  const handleShowDeletePopupClose = () => {
    setSelectedImages([]);
    setShowDeletePopup(false);
  };
  const handleShowDeletePopupOpen = () => {
    // if (totalSoftDeletedImages + 1 > RECENTLY_DELETED_LIMIT) {
    //   toast(
    //     <ToastMsg
    //       message={`Cannot delete images. Recently deleted limit of ${RECENTLY_DELETED_LIMIT} reached. Please upgrade your plan.`}
    //       danger={true}
    //     />,
    //     config.error_toast_config
    //   );
    //   return;
    // }
    setShowDeletePopup(true);
  };
  const handleShowMovePopupClose = () => {
    setSelectedImages([]);
    setShowMovePopup(false);
  };
  const handleShowMovePopupOpen = () => {
    setShowMovePopup(true);
  };
  useEffect(() => {
    createMasonryLayout();
  }, [localCategoryData]);

  const handleCheckboxToggle = (key, item) => {
    setSelectedImages((prev) => {
      if (checkedItems[key]) {
        return prev.filter((selected) => selected.id !== item.id);
      } else {
        return [...prev, item];
      }
    });
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleClearSelection = () => {
    setSelectedImages([]);
    setCheckedItems({});
    setActiveGalleryImages(false);
  };

  const totalSoftDeletedImages = galleryTitles.reduce((sum, { key }) => {
    return sum + (BusinessContext?.data?.recently_deleted?.[key]?.length || 0);
  }, 0);

  const handleDeleteImages = (data) => {
    // if (totalSoftDeletedImages + 1 > RECENTLY_DELETED_LIMIT) {
    //   toast(
    //     <ToastMsg
    //       message={`Cannot delete image. Recently deleted limit of ${RECENTLY_DELETED_LIMIT} reached. Please upgrade your plan.`}
    //       danger={true}
    //     />,
    //     config.error_toast_config
    //   );
    //   return;
    // }
    handleSoftDeleteImages(data);
    handleShowDeletePopupClose();
    // setSelectedImages([]);
    handleClearSelection();
  };

  const handleSingleImageDelete = (item) => {
    // if (totalSoftDeletedImages + 1 > RECENTLY_DELETED_LIMIT) {
    //   toast(
    //     <ToastMsg
    //       message={`Cannot delete image. Recently deleted limit of ${RECENTLY_DELETED_LIMIT} reached. Please upgrade your plan.`}
    //       danger={true}
    //     />,
    //     config.error_toast_config
    //   );
    //   return;
    // }
    setSelectedImages([item]);
    handleShowDeletePopupOpen();
  };

  // ****to close menu when click on out of the box****

  const handleUpgrade = () => {
    if (BusinessContext?.data?.billingDetails) {
      navigate(chooseYourPlan);
    } else {
      setShowBillingPopup(true);
    }
  };

  useEffect(() => {
    const handleDocClick = (event) => {
      const target = event.target;

      // if clicked inside the header menu (menu-wrapper) or any item dots/menu, ignore
      const clickedHeaderMenu = target.closest(".menu-wrapper");
      const clickedItemDots = target.closest(".menu_dots_icon_wrap");
      const clickedHoverMenu = target.closest(".hover-menu");

      if (!clickedHeaderMenu && !clickedItemDots && !clickedHoverMenu) {
        // outside any menu/dots → close everything
        setIsHovered(false);
        setActiveMenuId(null);
      }
    };

    document.addEventListener("click", handleDocClick);
    return () => document.removeEventListener("click", handleDocClick);
  }, []);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (menuRef.current && !menuRef.current.contains(event.target)) {
  //       setIsHovered(false);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (menuRef.current && !menuRef.current.contains(event.target)) {
  //       setActiveMenuId(false);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  useEffect(() => {
    if (props.categoryData?.data) {
      const newCategory = galleryTitles.find((item) => item.key === activeBtn);
      if (newCategory) {
        setLocalCategoryData({
          category: newCategory,
          data: BusinessContext?.data,
        });
      }
    }
  }, [activeBtn, props.categoryData?.data]); // Make sure props.categoryData?.data is in dependency

  // Add this new useEffect after the existing ones
  useEffect(() => {
    if (props.categoryData?.data && localCategoryData?.category) {
      setLocalCategoryData({
        ...localCategoryData,
        data: props.categoryData.data,
      });
    }
  }, [props.categoryData?.data]);

  useEffect(() => {
    if (props.categoryData?.category?.key) {
      setActiveBtn(props.categoryData.category.key);
    }
  }, [props.categoryData?.category?.key]);

  // Add this new useEffect to reset selections when tab changes
  useEffect(() => {
    setSelectedImages([]);
    setCheckedItems({});
    setActiveGalleryImages(false);
  }, [activeBtn]);

  return (
    <>
      <BillingPopUp
        show={showBillingPopup}
        handleClose={handleBillingPopupClose}
      />
      {width <= 768 && (
        <BottomSheetOptions
          theme={theme}
          show={showOptionsPopup}
          handleClose={handleOptionsPopupClose}
          handelOpenDelete={handleShowDeletePopupOpen}
          handelOpenMove={handleGallerypopupMoveOpen}
          handelOpenRecentlyDeleted={handleRecentlyDeletedPopupOpen}
          handleHidePopupOpen={() =>
            selectedImages[0] && handleSingleHideImage(selectedImages[0])
          }
          handlePinAction={() =>
            selectedImages[0] && handleSinglePinImage(selectedImages[0])
          }
          selectedItem={selectedImages[0]}
        />
      )}

      <FileUpload
        theme={theme}
        show={showFileUploadPopup}
        handleCloseAndUpdate={handleFileUploadPopupClose}
        headingSugested={`Add More ${localCategoryData?.category?.title}`}
        categoryData={localCategoryData}
        onUpdateData={handleUpdateData}
        category={localCategoryData?.category?.key}
        planDetails={BusinessContext?.data?.subscription}
      />
      {/* <GalleryPopupHide
        show={showHidePopup}
        handleCloseDelete={handleHidePopupClose}
        categoryData={props?.categoryData}
        onHideImages={handleHideImages}
      /> */}
      <GalleryPopupRecentlyDeleted
        show={showGallerypopupRecentlyDeleted}
        handleCloseDelete={handleRecentlyDeletedPopupClose}
        categoryData={localCategoryData}
        onDeleteImages={handlePermanentlyDeleteImages}
        onRestoreImages={handleRestoreImages}
        ref={deleteVariantRef}
      />
      <GalleryPopupUnusedImages
        show={showGallerypopupUnusedImages}
        handleCloseDelete={handleUnusedImagesPopupClose}
        categoryData={localCategoryData}
        onDeleteImages={handlePermanentlyDeleteImages}
        onRestoreImages={handleRestoreImages}
        ref={deleteVariantRef}
      />
      <DeleteConfirmPopup
        theme={theme}
        show={showDeletePopup}
        handleClose={handleShowDeletePopupClose}
        headingSugested={"Add More Project Photos & Renders"}
        data={selectedImages}
        deleteImages={handleDeleteImages}
        action="temporary"
      />
      {/* <GallerypopupDeleteVariant
        show={showGallerypopupDeleteVariant}
        handleCloseDelete={handleGallerypopupDeleteVariantClose}
        categoryData={props?.categoryData}
        onDeleteImages={handleSoftDeleteImages}
        ref={deleteVariantRef}
      /> */}
      {/* <GalleryPinPopup
        show={showGalleryPopupPin}
        handleCloseDelete={handlePinPopupClose}
        categoryData={props?.categoryData}
        onPinImages={handlePinImages}
      /> */}
      <MoveImagePopup
        theme={theme}
        show={showMovePopup}
        handleClose={handleShowMovePopupClose}
        selectedCount={selectedImages.length}
        categoryData={localCategoryData} // Pass the current category data
        onMoveImages={handleMoveImages} // Connect to your existing function
        selectedImages={selectedImages}
      />

      {/* <GalleryPopupMove
        show={showMovePopup}
        handleCloseDelete={handleGallerypopupMoveClose}
        categoryData={props?.categoryData}
        onMoveImages={handleMoveImages}
        ref={deleteVariantRef}
      /> */}
      <Modal
        {...props}
        centered
        className={`Gallery_popup_modal gallery_popup_edit nw_gl_popup ${
          theme === "dark" && "nw_gl_popup--dark-mode"
        }`}
        backdropClassName="custom-backdrop-gallery-edit"
        fullscreen={true}
      >
        {/* <Modal.Header closeButton></Modal.Header> */}
        <Modal.Header>
          <button
            className="custom-cancel-btn"
            onClick={() => {
              props.handleClose();
              setSelectedImages([]);
              setCheckedItems({});
              setActiveGalleryImages(false);
            }}
          >
            <img
              src={modalCloseIcon}
              alt="close-icon"
              className="ctm_img_bussine_edit_about"
            />
          </button>
        </Modal.Header>
        <Modal.Body className="overflow-x-hidden">
          <h2 className="Gallery_popup_heading d-flex align-items-center">
            {/* Edit {props?.categoryData?.category?.title} */}
            Archinza Gallery{" "}
            <span className="ar_gallery_count_st">
              ({totalImages} | {TOTAL_STORAGE} photos)
            </span>
            <div
              className="menu-wrapper"
              ref={menuRef}
              onClick={
                () => setIsHovered(!isHovered)
                // width <= 768
                //   ? handleOptionsPopupOpen
                //   : () => setIsHovered(!isHovered)
              }
            >
              <div className="three-dot-icon">
                <img
                  src={menuDotsIcon}
                  alt="menu"
                  className="menu_gallery_popup_edit_icon"
                />
              </div>
              <div className={`hover-menu ${isHovered ? "show" : "hide"}`}>
                {/* <div
                  className="menu-item"
                  onClick={handleGallerypopupDeleteVariantOpen}
                >
                  <img
                    src={deleteIconCircleOrange}
                    alt=""
                    className="menu_icon_popup"
                  />
                  Delete Images
                </div> */}

                {/* <div className="menu-item" onClick={handleHidePopupOpen}>
                  <img src={eyeClose} alt="" className="menu_icon_popup" /> Hide
                  Images
                </div> */}
                {/* <div className="menu-item" onClick={handlePinPopupOpen}>
                  <img src={pinIocn} alt="" className="menu_icon_popup" /> Pin
                  Images
                </div> */}

                {/* <div className="menu-item" onClick={handleGallerypopupMoveOpen}>
                  <img src={moveIocn} alt="" className="menu_icon_popup" /> Move
                  Images
                </div> */}
                <div
                  className="menu-item"
                  onClick={handleUnusedImagesPopupOpen}
                >
                  Unused Images
                </div>
                <div
                  className="menu-item border-0"
                  onClick={handleRecentlyDeletedPopupOpen}
                >
                  Recently Deleted
                </div>
              </div>
            </div>
          </h2>

          {/* <h3 className="popup_muted_title">
            Pin up to 5 photos to keep your favorites in the spotlight.
          </h3> */}

          <div className="sticky_top">
            <div className="gallery_fillter_btn_group Gallery_popup_heading">
              <div
                className={`filter_btn ${
                  activeBtn === "project_renders_media" ? "active" : ""
                }`}
                onClick={() => setActiveBtn("project_renders_media")}
              >
                Project Photos & Renders
              </div>
              <div
                className={`filter_btn ${
                  activeBtn === "completed_products_media" ? "active" : ""
                }`}
                onClick={() => setActiveBtn("completed_products_media")}
              >
                Products | Materials
              </div>
              <div
                className={`filter_btn ${
                  activeBtn === "sites_inprogress_media" ? "active" : ""
                }`}
                onClick={() => setActiveBtn("sites_inprogress_media")}
              >
                Sites In Progress
              </div>
              <div
                className={`filter_btn ${
                  activeBtn === "others_media" ? "active" : ""
                }`}
                onClick={() => setActiveBtn("others_media")}
              >
                Others
              </div>
            </div>

            <div className="btm_border_gl_modal">
              <div className="btm_heading_gallery">
                {totalImages} | {TOTAL_STORAGE} photos ({filledPercentage}%
                Filled){" "}
                {props?.categoryData?.data?.subscription?.plan?.isDefault &&
                  width > 767 && <span>Upgrade plan to increase storage</span>}
              </div>
              {props?.categoryData?.data?.subscription?.plan?.isDefault && (
                <div className="cta_btm_gl" onClick={handleUpgrade}>
                  <img src={upgradeIcon} alt="upgrde" />
                  <div>Upgrade Your Plan</div>
                </div>
              )}
            </div>

            <div
              className={`tt_cnt_gl ${
                width < 767 && activeGallerImages && "pt-0"
              }`}
            >
              {width > 767 || !activeGallerImages
                ? `${imagesData?.length || 0} Photos`
                : ""}
              {activeGallerImages ? (
                <div className="actions_gallery_all_images">
                  <div className="close_galler_all_actions">
                    <img
                      src={clsoeIconActionIcon}
                      alt="close"
                      className="close_ic_gl_a"
                      onClick={handleClearSelection}
                    />
                    <span className="act_img_cnt">
                      {selectedImages.length} images selected
                    </span>
                  </div>
                  <div className="actions_icons_wraper_gallery">
                    <div className="wrapper_ic_act_tooltip">
                      <img
                        src={pinIconActionIcon}
                        alt="pin images"
                        className="act_img_gl"
                        onClick={() => handleBulkPinImages()}
                      />
                      <div className="tootlip_user_info_gallery">
                        Pin Images
                      </div>
                    </div>
                    <div className="wrapper_ic_act_tooltip">
                      <img
                        src={hideShowActionIcon}
                        alt="hide images"
                        className="act_img_gl"
                        onClick={() => handleBulkHideImages()}
                      />
                      <div className="tootlip_user_info_gallery">
                        Hide Images
                      </div>
                    </div>{" "}
                    <div className="wrapper_ic_act_tooltip">
                      <img
                        src={MoveActionIcon}
                        alt="move images"
                        className="act_img_gl"
                        onClick={handleGallerypopupMoveOpen}
                      />
                      <div className="tootlip_user_info_gallery">
                        Move Images
                      </div>
                    </div>{" "}
                    <div className="wrapper_ic_act_tooltip">
                      <img
                        src={DeleteActionIcon}
                        alt="delete images"
                        className="act_img_gl mx-0"
                        onClick={handleShowDeletePopupOpen}
                      />
                      <div className="tootlip_user_info_gallery">
                        Delete Images
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                imagesData?.length > 0 && (
                  <div className="d-flex">
                    <div
                      className="cta_sl_all_gl_img"
                      style={{
                        marginRight: "1em",
                        border: !activeGallerImages
                          ? "1px solid rgba(141, 141, 141, 0.6)"
                          : "none",
                        backgroundColor: "#fff",
                        color: "#000",
                      }}
                      onClick={() => setActiveGalleryImages(true)}
                    >
                      Select Multiple Images
                    </div>

                    <div
                      className="cta_sl_all_gl_img select_all--cta-sp"
                      onClick={handleSelectAll}
                    >
                      Select All Images
                    </div>
                  </div>
                )
              )}
            </div>
          </div>

          <div className="masonry-gallery-two position-relative">
            {arrangedImages.map((column, colIndex) => (
              <div className="masonry-column" key={colIndex}>
                {column.map((item, index) => {
                  const itemKey = `${colIndex}-${index}`;
                  const isChecked = checkedItems[itemKey];
                  return (
                    <>
                      <div
                        className="masonry-item position-relative"
                        key={index}
                      >
                        {/* -------------------------------------------------- */}
                        {/* 🔥 NEW BLURHASH COMPONENT REPLACING OLD <IMG> 🔥 */}
                        {/* -------------------------------------------------- */}

                        <BlurGalleryImage
                          item={item}
                          activeGallerImages={activeGallerImages}
                          onClick={() => handleCheckboxToggle(itemKey, item)}
                        />
                        {/* <img
                          src={item.src}
                          alt={`Gallery ${index}`}
                          loading="lazy"
                          className={
                            !activeGallerImages &&
                            !item.visibility &&
                            "opacity-40"
                          }
                          style={{
                            cursor: activeGallerImages ? "pointer" : "auto",
                          }}
                          onClick={() => handleCheckboxToggle(itemKey, item)}
                        /> */}
                        {/* skeleton background div */}
                        {/* <div
                          className="img-skeleton-bg"
                          style={{
                            // aspectRatio: item.width && item.height ? `${item.width} / ${item.height}` : "auto",
                            aspectRatio:  "auto",
                          }}
                        >
                          <img
                            src={item.src}
                            alt={`Gallery ${index}`}
                            loading="lazy"
                            decoding="async"
                            className={
                              !activeGallerImages &&
                              !item.visibility &&
                              "opacity-40"
                            }
                            style={{
                              cursor: activeGallerImages ? "pointer" : "auto",
                            }}
                            onClick={() => handleCheckboxToggle(itemKey, item)}
                            onLoad={(e) => {
                              // Set parent height based on loaded image
                              const imgHeight = e.target.offsetHeight;
                              e.target.parentElement.style.minHeight = `${imgHeight}px`;
                            }}
                          />
                        </div> */}
                        {activeGallerImages && (
                          <div
                            onClick={() => handleCheckboxToggle(itemKey, item)}
                            className={`${
                              isChecked
                                ? "checked check_box_ctm_popup_wraper"
                                : "check_box_ctm_popup_wraper"
                            }`}
                          >
                            {/* Hidden input just to keep HTML semantics */}
                            <input
                              type="checkbox"
                              checked={isChecked || false}
                              onChange={() => {}}
                              className="hiden_ip_ctm_popup"
                            />

                            {isChecked && (
                              <img
                                src={chakMarkWhite}
                                alt="Checkmark"
                                className="chek_mark_ctm_popup"
                                style={{
                                  zIndex: "0",
                                }}
                              />
                            )}
                          </div>
                        )}

                        {activeGallerImages && item.pinned && (
                          <img
                            src={pinBlack}
                            alt="pin"
                            className={`pined_images_icon ${
                              activeGallerImages && "pin_active_select_all"
                            }`}
                          />
                        )}

                        {activeGallerImages && !item.visibility && (
                          <img
                            src={eyeCloseBlack}
                            alt="pin"
                            className={`pined_images_icon ${
                              activeGallerImages && "pin_active_select_all"
                            }`}
                          />
                        )}
                        {!activeGallerImages && item.pinned && (
                          <img
                            src={pinBlack}
                            alt="pin"
                            className="pined_images_icon"
                          />
                        )}
                        {!activeGallerImages && !item.visibility && (
                          <img
                            src={eyeCloseBlack}
                            alt="pin"
                            className="pined_images_icon"
                          />
                        )}
                      </div>
                      <div
                        className={`menu_dots_icon_wrap position-relative ${
                          activeGallerImages ? "d-none" : ""
                        }`}
                      >
                        <img
                          src={dotsMenuIcon}
                          alt="options"
                          className="dots_menu_opt"
                          // ref={menuRef}
                          onClick={() => {
                            if (width <= 768) {
                              // handleOptionsPopupOpen();
                              handleOptionsPopupOpen(item);
                              setShowOptionsPopup(true);
                            } else {
                              // functional updater — safer
                              setActiveMenuId((prev) =>
                                prev === item.id ? null : item.id
                              );
                            }
                          }}

                          // onClick={() => {
                          //   if (width <= 768) {
                          //     handleOptionsPopupOpen();
                          //   } else {
                          //     setActiveMenuId(
                          //       activeMenuId === item.id ? false : item.id
                          //     );
                          //   }
                          // }}
                        />
                        <div
                          className={`hover-menu hr_menu_idv_img ${
                            activeMenuId === item.id ? "show" : "hide"
                          }`}
                        >
                          <div
                            className="menu-item"
                            onClick={() => handleSingleImageDelete(item)}
                          >
                            <img
                              src={deleteIconCircleOrange}
                              alt=""
                              className="menu_icon_popup"
                            />
                            Delete Image
                          </div>

                          <div
                            className="menu-item"
                            onClick={() => handleSingleHideImage(item)}
                          >
                            <img
                              src={eyeClose}
                              alt=""
                              className="menu_icon_popup"
                            />{" "}
                            {item.visibility ? "Hide Image" : "Unhide Image"}
                          </div>
                          <div
                            className="menu-item"
                            onClick={() => handleSinglePinImage(item)}
                          >
                            <img
                              src={pinIocn}
                              alt=""
                              className="menu_icon_popup"
                            />{" "}
                            {item.pinned ? "Unpin Image" : "Pin Image"}
                          </div>

                          <div
                            className="menu-item border-0"
                            onClick={() => {
                              setSelectedImages([item]);
                              handleGallerypopupMoveOpen();
                            }}
                          >
                            <img
                              src={moveIocn}
                              alt=""
                              className="menu_icon_popup"
                            />{" "}
                            Move Image
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            ))}
          </div>

          <div
            className="addMore_gallery_image"
            onClick={handleFileUploadPopupOpen}
          >
            <div className="addMore_wrapper">
              <img
                src={addIconGallery}
                alt="add more"
                className="addMore_icon"
              />
              Add More Photos
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GalleryEditPopupDefault;
